import { BasketResponse } from 'Services';

export const headerCartResponse: BasketResponse = {
  numberOfProducts: '9',
};
